// extracted by mini-css-extract-plugin
var _1 = "ErrorStyle-module__error___Iompw";
var _2 = "ErrorStyle-module__error--message___NVIfQ";
var _3 = "ErrorStyle-module__error--message___NVIfQ";
var _4 = "ErrorStyle-module__redirect___ctkwg";
export { _1 as "error", _2 as "error--message", _3 as "errorMessage", _4 as "redirect" }
